/* =========================================================
   Southern Made – product page helpers
   <sm-recommendations>  loads Shopify recommendations (Section Rendering)
   <sm-recently-viewed>  shows recently viewed products (same storage key
                         as the theme: "recentlyViewedProducts")
   Quick add for [data-sm-quick-add] buttons outside <sm-collection>
   ========================================================= */
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var KEY = 'recentlyViewedProducts';

  function hideSection(el) {
    var wrap = el.closest('.shopify-section');
    if (wrap) wrap.style.display = 'none';
  }
  function swapInner(el, html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector(selector);
    if (!fresh || !fresh.querySelector('.SmCarousel__Slide')) return false;
    el.innerHTML = fresh.innerHTML;
    return true;
  }
  function onVisible(el, fn) {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); fn(); }
    }, { rootMargin: '0px 0px 400px 0px' });
    io.observe(el);
  }

  /* ---------------- Recommendations ---------------- */
  if (!customElements.get('sm-recommendations')) {
    class SmRecommendations extends HTMLElement {
      connectedCallback() {
        if (this._ready || this.dataset.loaded === 'true' || !this.dataset.url) return;
        this._ready = true;
        var self = this;
        onVisible(this, function () {
          fetch(self.dataset.url)
            .then(function (r) { return r.text(); })
            .then(function (html) {
              if (!swapInner(self, html, 'sm-recommendations')) hideSection(self);
            })
            .catch(function () { hideSection(self); });
        });
      }
    }
    customElements.define('sm-recommendations', SmRecommendations);
  }

  /* ---------------- Recently viewed ---------------- */
  function readIds() {
    try { return JSON.parse(window.localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function writeIds(ids) {
    try { window.localStorage.setItem(KEY, JSON.stringify(ids)); } catch (e) {}
  }

  if (!customElements.get('sm-recently-viewed')) {
    class SmRecentlyViewed extends HTMLElement {
      connectedCallback() {
        if (this._ready || this.dataset.loaded === 'true') return;
        this._ready = true;
        var current = parseInt(this.dataset.productId, 10) || 0;
        var limit = parseInt(this.dataset.limit, 10) || 8;
        var ids = readIds().filter(function (id) { return id !== current; }).slice(0, limit);

        if (current) {
          var all = readIds().filter(function (id) { return id !== current; });
          all.unshift(current);
          writeIds(all.slice(0, 24));
        }
        if (this.hasAttribute('data-design-mode')) return;
        if (!ids.length) { hideSection(this); return; }

        var self = this;
        var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
        var url = this.dataset.searchUrl + '?q=' + encodeURIComponent(q) + '&type=product&section_id=' + this.dataset.sectionId;
        onVisible(this, function () {
          fetch(url)
            .then(function (r) { return r.text(); })
            .then(function (html) {
              if (!swapInner(self, html, 'sm-recently-viewed')) { hideSection(self); return; }
              /* keep "most recent first" order */
              var track = self.querySelector('.SmCarousel__Track');
              if (!track) return;
              ids.slice().reverse().forEach(function (id) {
                var slide = track.querySelector('[data-product-id="' + id + '"]');
                if (slide) track.insertBefore(slide, track.firstChild);
              });
            })
            .catch(function () { hideSection(self); });
        });
      }
    }
    customElements.define('sm-recently-viewed', SmRecentlyViewed);
  }

  /* ---------------- Quick add (outside the collection page) ---------------- */
  if (window.SmQuickAddBound) return;
  window.SmQuickAddBound = true;

  function updateCount(count) {
    document.querySelectorAll('.CartCountBubble').forEach(function (b) { b.classList.toggle('Visible', count > 0); });
    document.querySelectorAll('.CartCountBubble__Count, [data-cart-count]').forEach(function (c) {
      if (!c.classList.contains('VisuallyHidden')) c.textContent = count;
    });
  }
  function toast(message, item) {
    var t = document.querySelector('.SmToast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'SmToast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.innerHTML = '';
    if (item && item.image) {
      var img = document.createElement('img');
      img.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      img.alt = '';
      t.appendChild(img);
    }
    var box = document.createElement('div');
    if (item) { var s = document.createElement('strong'); s.textContent = item.product_title; box.appendChild(s); box.appendChild(document.createElement('br')); }
    box.appendChild(document.createTextNode(message));
    t.appendChild(box);
    t.classList.add('is-visible');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('is-visible'); }, 3000);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sm-quick-add]');
    if (!btn || btn.closest('sm-collection') || btn.classList.contains('is-loading')) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    var holder = btn.closest('[data-after-add]');
    var mode = holder ? holder.dataset.afterAdd : 'drawer';
    var drawerSection = document.getElementById('shopify-section-cart-drawer');
    var body = { items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] };
    if (drawerSection) body.sections = 'cart-drawer';

    fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to cart');
        if (res.data.sections && res.data.sections['cart-drawer'] && drawerSection) {
          var doc = new DOMParser().parseFromString(res.data.sections['cart-drawer'], 'text/html');
          var fresh = doc.getElementById('shopify-section-cart-drawer');
          drawerSection.innerHTML = fresh ? fresh.innerHTML : doc.body.innerHTML;
        }
        return fetch(ROOT + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        if (mode === 'cart') { window.location.href = ROOT + 'cart'; return; }
        var trigger = mode === 'drawer' && document.querySelector('#Header__CartTrigger[data-tg-toggle="Drawer"], [data-tg-target="#CartDrawer"]');
        if (trigger) trigger.click();
        else toast('Added to your cart', cart.items && cart.items[0]);
      })
      .catch(function (err) { toast(err.message); })
      .finally(function () { btn.classList.remove('is-loading'); });
  });
})();

/* =========================================================
   Main product helpers (TeeInBlue renders late, so we watch the DOM)
   - Thumbnail arrows: tag prev/next so CSS can place them on top
   - Hide the description TeeInBlue prints under add to cart
   - Keep theme color swatches at the size set in the section
   ========================================================= */
(function () {
  function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }

  function tagThumbButtons(root) {
    root.querySelectorAll('.tee-thumbnails').forEach(function (wrap) {
      var btns = wrap.querySelectorAll('.tee-thumbnails__button');
      btns.forEach(function (b, i) {
        if (b.dataset.smDir) return;
        var hint = ((b.className || '') + ' ' + (b.getAttribute('aria-label') || '')).toLowerCase();
        var dir = /prev|left|back/.test(hint) ? 'prev' : /next|right|forward/.test(hint) ? 'next' : (i === 0 ? 'prev' : 'next');
        b.dataset.smDir = dir;
        if (!b.getAttribute('aria-label')) b.setAttribute('aria-label', dir === 'prev' ? 'Previous images' : 'Next images');
      });
      wrap.classList.toggle('SmThumbs--nav', btns.length > 0);
    });
  }

  function hideTeeDescription(root) {
    if (!root.classList.contains('SmProduct--teeHideDesc')) return;
    var actions = root.querySelector('#teeFormActions, .tee-form-actions');
    if (!actions) return;
    var stopAt = root.querySelector('.ProductSummary') || root;
    var walker = document.createTreeWalker(stopAt, NodeFilter.SHOW_ELEMENT);
    var node;
    while ((node = walker.nextNode())) {
      if (!(actions.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING)) continue;
      if (actions.contains(node) || node.closest('.SmBulk, .Product__Block--descriptionCollapsible, .Product__Block--collapsibleInfoJS, .Accordion__Item')) continue;
      var own = '';
      node.childNodes.forEach(function (c) { if (c.nodeType === 3) own += c.textContent; });
      if (!/^\s*description\s*:?\s*$/i.test(own)) continue;
      /* climb to the block that holds this description, but stay under the shared parent */
      var el = node;
      while (el.parentElement && el.parentElement !== stopAt && !el.parentElement.contains(actions)) el = el.parentElement;
      el.classList.add('SmTeeDescHidden');
    }
  }

  function visibleText(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), t, out = '';
    while ((t = w.nextNode())) {
      if (!t.textContent.trim()) continue;
      var r = t.parentElement.getBoundingClientRect();
      if (r.width > 2 && r.height > 2) out += t.textContent.trim();
    }
    return out;
  }

  /* Variant buttons: text options (S, M, 2XL, Youth Small…) get normal one-line text,
     color/image swatches get the swatch size, and each option row gets even spacing.
     - options are grouped by their radio name, so Size and Color stay on their own lines
     - every button is measured once (data-sm-kind), so nothing jumps while you browse */
  function styleOptions(root) {
    root.querySelectorAll('.Product__Block--variantPicker').forEach(function (block) {
      var groups = {}, order = [];
      function add(key, unit) {
        if (!groups[key]) { groups[key] = []; order.push(key); }
        if (groups[key].indexOf(unit) < 0) groups[key].push(unit);
      }
      block.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(function (inp) {
        var lab = null;
        if (inp.id) { try { lab = block.querySelector('label[for="' + CSS.escape(inp.id) + '"]'); } catch (e) {} }
        if (!lab) lab = inp.closest('label');
        if (lab) add('n:' + (inp.name || inp.id), lab);
      });
      block.querySelectorAll('[role="radio"]').forEach(function (b) {
        var g = b.closest('[role="radiogroup"]') || b.parentElement;
        if (!g.dataset.smGroup) g.dataset.smGroup = 'g' + Math.random().toString(36).slice(2, 8);
        add('r:' + g.dataset.smGroup, b);
      });

      /* each option group on its own line: find the box that holds all groups and
         make every group's wrapper inside it full width */
      if (order.length > 1) {
        var all = [];
        order.forEach(function (k) { all = all.concat(groups[k]); });
        var common = all[0].parentElement;
        while (common && common !== block.parentElement && !all.every(function (u) { return common.contains(u); })) common = common.parentElement;
        if (common) {
          order.forEach(function (k) {
            var w = groups[k][0];
            while (w.parentElement && w.parentElement !== common) w = w.parentElement;
            var mixed = order.some(function (o) { return o !== k && groups[o].some(function (u) { return w.contains(u); }); });
            if (!mixed && w !== common) w.classList.add('SmOpt__Group');
          });
        }
      }

      order.forEach(function (key) {
        var units = groups[key];
        units.forEach(function (u) {
          if (!u.dataset.smKind) u.dataset.smKind = visibleText(u) ? 'text' : 'swatch';
          u.classList.add('SmOpt__Unit', u.dataset.smKind === 'text' ? 'SmOpt__Text' : 'SmOpt__Swatch');
        });
        if (units.length < 2) return; /* single value: leave the theme layout alone */

        /* lowest common ancestor of this group's buttons = the row */
        var row = units[0].parentElement;
        while (row && row !== block && !units.every(function (u) { return row.contains(u); })) row = row.parentElement;
        if (!row) return;
        /* never turn a box that also holds another option group into the row */
        var foreign = order.some(function (k) { return k !== key && groups[k].some(function (u) { return row.contains(u); }); });
        if (foreign) return;
        row.classList.add('SmOpt');
        units.forEach(function (u) {
          var item = u;
          while (item.parentElement && item.parentElement !== row) item = item.parentElement;
          item.classList.add('SmOpt__Item');
        });
      });
    });
  }

  function run(root) {
    tagThumbButtons(root);
    hideTeeDescription(root);
    styleOptions(root);
  }

  function init() {
    document.querySelectorAll('.SmProduct').forEach(function (root) {
      if (root.dataset.smHelpers) return;
      root.dataset.smHelpers = '1';
      run(root);
      var queued = false;
      var later = function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; run(root); });
      };
      new MutationObserver(later).observe(root, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
